module.exports = __webpack_public_path__ + "img/user-add.23f033f5.svg";